export const isSpotifyTrack = (url: string) => {
    const spotifyTrackRegExp = /^(https?:\/\/)?(www\.)?(open\.)?spotify\.com\/(track|playlist|album)\/([a-zA-Z0-9]+)/;
    return spotifyTrackRegExp.test(url);
};

export const extractSpotifyTrackId = (url: string) => {
    const regExp = /track\/([a-zA-Z0-9]+)/;
    const match = url.match(regExp);
    return (match && match[1]) ? match[1] : null;
};

export const isSpotifyPlaylist = (url: string) => {
    const spotifyPlaylistRegExp = /^(https?:\/\/)?(www\.)?(open\.)?spotify\.com\/playlist\/([a-zA-Z0-9]+)/;
    return spotifyPlaylistRegExp.test(url);
};

export const extractSpotifyPlaylistId = (url: string) => {
    const regExp = /playlist\/([a-zA-Z0-9]+)/;
    const match = url.match(regExp);
    return (match && match[1]) ? match[1] : null;
};

export const isSpotifyAlbum = (url: string) => {
    const spotifyAlbumRegExp = /^(https?:\/\/)?(www\.)?(open\.)?spotify\.com\/album\/([a-zA-Z0-9]+)/;
    return spotifyAlbumRegExp.test(url);
};

export const extractSpotifyAlbumId = (url: string) => {
    const regExp = /album\/([a-zA-Z0-9]+)/;
    const match = url.match(regExp);
    return (match && match[1]) ? match[1] : null;
};

export const extractSpotifyId = (url: string): {
    type: 'playlist' | 'album' | 'track';
    id: string | null;
} => {
    if (isSpotifyPlaylist(url)) {
        return { type: 'playlist', id: extractSpotifyPlaylistId(url) };
    }
    if (isSpotifyAlbum(url)) {
        return { type: 'album', id: extractSpotifyAlbumId(url) };
    }
    return { type: 'track', id: extractSpotifyTrackId(url) };
};

export const isSoundCloudTrack = (url: string) => {
    const soundCloudRegExp = /^(https?:\/\/)?(www\.)?(soundcloud\.com)\/([a-zA-Z0-9_-]+)(\/sets\/[a-zA-Z0-9_-]+|\/[a-zA-Z0-9_-]+)/;
    const soundCloudShortRegExp = /^(https?:\/\/)?(www\.)?(on\.soundcloud\.com)\/([a-zA-Z0-9]+)/;
    return soundCloudRegExp.test(url) || soundCloudShortRegExp.test(url);
};

export const extractSoundCloudTrackUrl = (url: string) => {
    // Check if it's a shortened SoundCloud URL
    const shortSoundCloudRegExp = /^(https?:\/\/)?(www\.)?(on\.soundcloud\.com)\/([a-zA-Z0-9]+)/;

    if (shortSoundCloudRegExp.test(url)) {
        // Return a special marker with the original URL that needs resolution
        return `__RESOLVE_URL__${url}`;
    }

    // For regular SoundCloud URLs, return as is
    return url;
};

export const isYouTubeVideo = (url: string) => {
    const youtubeRegExp = /^(https?:\/\/)?(www\.)?(youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    return youtubeRegExp.test(url);
};

export const extractYouTubeVideoId = (url: string) => {
    const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regExp);
    return (match && match[1]) ? match[1] : null;
};
